// extracted by mini-css-extract-plugin
module.exports = {"root":"_3TVDM","ShinyMenuIIButtonNSkin":"DlvKD","shinyMenuIiButtonNSkin":"DlvKD","linkElement":"_2UP8Y","extra":"_32_q1","wrapper":"_254IV","label":"_3ctE7"};